import { Component } from '@angular/core';
import { ServicesService } from 'src/services/services.service';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Location } from '@angular/common';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-app-add-event',
  templateUrl: './app-add-event.component.html',
  styleUrls: ['./app-add-event.component.scss'],
  standalone: false
})
export class AppAddEventComponent {
  message!: string;
  logofileURL!: string | ArrayBuffer | null;
  logoPath: any;
  isOld1 = false;
  imagefileURL!: any | ArrayBuffer;
  imgType!: any | ArrayBuffer;
  imagePath: any;

  public model = {
    editorData: ''
  };

  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: '0',
    maxHeight: 'auto',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Write Description....',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    fonts: [
      { class: 'arial', name: 'Arial' },
      { class: 'times-new-roman', name: 'Times New Roman' },
      { class: 'calibri', name: 'Calibri' },
      { class: 'comic-sans-ms', name: 'Comic Sans MS' }
    ],
    customClasses: [
      {
        name: 'quote',
        class: 'quote',
      },
      {
        name: 'redText',
        class: 'redText'
      },
      {
        name: 'titleText',
        class: 'titleText',
        tag: 'h1',
      }
    ],
    uploadUrl: 'v1/image',
    uploadWithCredentials: false,
    sanitize: true,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [
      ['bold', 'italic'],
      ['fontSize']
    ]
  };
  event_name: any;
  event_type: any;
  description: any;
  address: any;
  reg_fee: any;
  total_reg: any;
  from_date: any;
  to_date: any;
  event_logo: any;
  event_image: any;
  from_time: any;
  to_time: any;
  type: any = 'public';
  is_active: any = '1';
  user_id: any;
  eventForm!: FormGroup;
  event_result: any;

  constructor(
    private service: ServicesService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private location: Location,
    private router: Router
  ) {
    this.user_id = this.route.snapshot.params['user_id'];
  }

  ngOnInit(): void {
    this.user_id = this.route.snapshot.params['user_id'];
    this.eventForm = this.fb.group({
      event_image: ['', Validators.required],
      event_logo: ['', Validators.required],
      event_name: ['', Validators.required],
      event_type: [''],
      from_date: ['', Validators.required],
      to_date: ['', Validators.required],
      from_time: ['', Validators.required],
      to_time: ['', Validators.required],
      is_active: [0, Validators.required],
      reg_fee: [0, Validators.required],
      total_reg: [0, Validators.required],
      type: ['', Validators.required],
      address: [''],
      description: [''],
      user_id: ['']
    });
    this.getType();
  }

  getType() {
    this.service.get_eventtype().subscribe(
      (data: any) => {
        this.event_result = data.data;
      }
    );
  }

  previewplogo(files: any) {
    if (files.length === 0) {
      return;
    }
    var mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      this.message = 'Only images are supported.';
      return;
    }
    var reader = new FileReader();
    reader.readAsDataURL(files[0]);
    reader.onload = (_event) => {
      this.logofileURL = reader.result;
      this.imgType = 'event_logo';
      this.service.uploadimage(this.logofileURL, this.imgType).subscribe((data: any) => {
        this.logoPath = data['image_name'];
      });

    };
  }


  previewpimage(files: any) {
    if (files.length === 0) {
      return;
    }
    var mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      this.message = 'Only images are supported.';
      return;
    }
    var reader = new FileReader();
    reader.readAsDataURL(files[0]);
    reader.onload = (_event) => {
      this.imagefileURL = reader.result;
      this.imgType = 'event_image';
      this.service.uploadimage(this.imagefileURL, this.imgType).subscribe((data: any) => {
        this.imagePath = data['image_name'];
      });
    };
  }

  onSubmit() {

    this.eventForm.patchValue({
      event_image: this.imagePath,
      event_logo: this.logoPath,
      user_id: this.user_id
    })

    if (this.eventForm.invalid) {
      this.toastr.error('Please Fill Required Field');
      return;
    }

    this.service.add_Event(this.eventForm.value).subscribe(
      (data: any) => {
        if (data.flag == true) {
          this.toastr.success("Event Added Successfully");
        } else {
          this.toastr.error("Something Went Wrong");
        }
      },
      (error) => {
        console.error(error);
        this.toastr.error("An error occurred while adding the event.");
      }
    );
  }

  Cancel() {
    this.location.back();
  }

}
